// src/pages/profile.jsx
import React, { useEffect, useState } from 'react';
import { 
  Row, 
  Col, 
  Input, 
  Button,
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter
} from 'reactstrap';

import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchUserDataRequest,
  fetchUserProfilePicRequest,
  clearUser
} from '../store/user/userSlice';

import axiosInstance from '../utils/axiosInstance';

import PageTitle from '../components/common/pageTitle';
import placeholder from '../assets/images/placeholder_image.jpg';



const Profile = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { name, email, profilePic, points } = useSelector((state) => state.user);

  /*---- Redux userData ----*/

  // User data from Redux store
  const userData = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchUserDataRequest());
  }, [dispatch]);

  useEffect(() => {
    if (userData.profilePic) {
      dispatch(fetchUserProfilePicRequest(userData.profilePic));
    }
  }, [userData.profilePic, dispatch]);

  /*---- Redux userData ----*/


  // Modal states
  const [isNewAccountNameModalOpen, setIsNewAccountNameModalOpen] = useState(false);
  const [newAccountName, setNewAccountName] = useState('');
  // Toggle modal
  const toggleNewAccountNameModal = () => {
    setSuccess('');
    setError('');
    setIsNewAccountNameModalOpen(!isNewAccountNameModalOpen);
  }

  // Handle account name change
  const handleAccountNameChange = async () => {
    setError('');
    setSuccess('');

    if (!newAccountName.trim()) {
      setError('請輸入有效的帳號名稱');
      return;
    }

    try {
      const response = await axiosInstance.post('/api/auth/update-account-name', {
        newAccountName,
      });

      setSuccess('帳號名稱已更新');
      dispatch(fetchUserDataRequest());
      setIsNewAccountNameModalOpen(false);
    } catch (err) {
      console.log('err:', err);
      const errorMsg = err.response?.data?.error || '更新帳號名稱時出錯';
      setError(errorMsg);
    }
  };




  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [previewImage, setPreviewImage] = useState(''); // Store preview image
  const [profilePicFile, setProfilePicFile] = useState(null); // new profile pic to be uploaded
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');


  // Handle Password Change
  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post('/api/auth/change-password', {
        currentPassword,
        newPassword,
      });

      setSuccess('Password updated successfully.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');

    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Server error. Please try again.';
      setError(errorMsg);
    }
  };

  // Handle Profile Picture Upload
  const handleProfilePicUpload = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!profilePicFile) {
      setError('請選擇要上傳的圖片');
      return;
    }

    const formData = new FormData();
    formData.append('profilePicFile', profilePicFile);

    try {
      const response = await axiosInstance.post('/api/auth/update-profile-pic', formData);
      setSuccess('成功更改帳號頭像');
      setPreviewImage(''); // Clear preview

      dispatch(fetchUserDataRequest());

    } catch (err) {
      console.log('error', err);
      const errorMsg = err.response?.data?.error || 'Error uploading profile picture.';
      setError(errorMsg);
    }
  };

  // Preview image before upload
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSuccess('');
      setError('');
      setProfilePicFile(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  return (
    <>

      <PageTitle link={"用戶資料"} pageName={"用戶資料"} />

      <div className="profile-area ptb-100">
        <div className="container">
          <div className="profile-info">

            <Row>

              <Col xs={12} style={{ marginBottom:'2rem' }}>
                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}
              </Col>

              <Col xs={12} lg={4} style={{ marginBottom:'3rem' }}>
                <h3>帳號基本資訊</h3>

                <div className="user-details">
                  <div>
                    <img
                      src={userData.profilePicData || placeholder}
                      alt="Profile"
                      className="rounded-circle mb-3"
                      style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                    />
                  </div>
                  <div style={{ padding:'10px 0px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p style={{ margin:'5px 0px' }}>
                        帳號名稱：
                        <strong>{ name==='User' ? email.split('@')[0] : name }</strong>
                      </p>
                      <Button
                        size="sm"
                        color="outline-primary"
                        onClick={toggleNewAccountNameModal}
                        style={{ 
                          marginLeft: '10px',
                          height: '30px',
                          width: '30px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: '#50a5f1',
                          borderColor: '#50a5f1'
                        }}
                      >
                        <i className="fas fa-pen"></i>
                      </Button>
                    </div>

                    <p style={{ margin:'5px 0px 7px 0px' }}>Email：<strong>{email}</strong></p>
                    <p style={{ margin:'5px 0px' }}>平台點數：<strong>{points}</strong></p>
                  </div>
                </div>
              </Col>

              <Col xs={12} lg={8} style={{ marginBottom:'3rem' }}>
                <form onSubmit={handlePasswordChange}>
                  <h3>更改密碼</h3>
                  <div style={{ display: 'flex', padding: '20px 0px', gap: '8px', flexDirection: 'column' }}>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="當前密碼"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="新密碼"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="確認新密碼"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <Button color="danger" style={{ color:'warning' }} type="submit">更新密碼</Button>
                </form>
              </Col>
            </Row>

            <Row>
              <Col xs={12} lg={4}>
                <form onSubmit={handleProfilePicUpload} encType="multipart/form-data" className="mt-4">
                  <h3>更新帳號頭像</h3>
                  <div style={{ marginBottom: '1rem' }}>
                    <img
                      src={previewImage || placeholder}
                      alt="Profile"
                      className="rounded-circle mb-3"
                      style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                    />
                    <div className="form-group">
                      <Input
                        type="file"
                        className="form-control"
                        onChange={handleImageChange}
                        accept="image/*"
                        required
                      />
                    </div>
                  </div>
                  <Button color="success" type="submit">更新頭像</Button>
                </form>
              </Col>
            </Row>

          </div>
        </div>

        {/* New Account Name Modal */}
        <Modal isOpen={isNewAccountNameModalOpen} toggle={toggleNewAccountNameModal}>
          <ModalHeader toggle={toggleNewAccountNameModal}>更改帳號名稱</ModalHeader>
          <ModalBody>
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <div className="form-group">
              <div><label htmlFor="accountName">新帳號名稱</label></div>
              <div style={{ marginTop:'10px' }}>
                <Input
                  type="text"
                  id="accountName"
                  value={newAccountName}
                  onChange={(e) => setNewAccountName(e.target.value)}
                  placeholder="輸入新的帳號名稱"
                  style={{
                    border: '1px solid #a8afb4',
                    borderRadius: '15px'
                  }}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleAccountNameChange}>提交</Button>
            <Button color="secondary" onClick={toggleNewAccountNameModal}>取消</Button>
          </ModalFooter>
        </Modal>

      </div>
    </>
  );
};

export default Profile;

